"use client";

import dynamic from "next/dynamic";
import { CarouselSkeleton } from "./CarouselSkeleton";

const HeroBeforeAfterCarousel = dynamic(
  () => import("./HeroBeforeAfterCarousel").then((m) => ({ default: m.HeroBeforeAfterCarousel })),
  { ssr: false, loading: () => <CarouselSkeleton /> },
);

export function HeroCarouselSection() {
  return <HeroBeforeAfterCarousel />;
}
